<!----------------------------   Program description   ----------------------------
- Vue Name ID   :
- Vue Name  :
- Author      :
- Create Date :
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div id="layer-wrap" class="print_page"
       v-if="initAt">
    <h1 style="font-size: 35px; text-align: center;">납 품 확 인 서</h1>
    <div style="display: flex; padding-bottom: 30px; padding-top: 50px;">
      <div class="box-gw-common-search"
           style="width: 50%; padding-top: 60px;">
        <div class="__common-search">
          <table>
            <colgroup>
              <col style="width:30%" />
              <col style="width:auto;"/>
            </colgroup>
            <tbody>
            <tr>
              <th style="text-align:left;">어린이집명 : </th>
              <td>
                <span class="pc07">{{srvcInfo.fcltNm}}</span>
              </td>
            </tr>
            <tr>
              <th style="text-align:left;">납품일 : </th>
              <td>
                <span class="pc07"></span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <table class="tb-col __pd-half"
             style="width: 60%;">
        <colgroup>
          <col style="width:15%;" />
          <col style="width:40%;"/>
        </colgroup>
        <tbody>
        <tr>
          <th>회사명</th>
          <td  >(주)온앤온정보시스템</td>
        </tr>
        <tr>
          <th>대표자성명</th>
          <td><span style="padding-right: 40px">김 종 찬</span>
            <img class="apply-print-padding"
                 style="position: absolute; margin-left: -27px;margin-top: -12px;width: 40px;"
                 src="../../../../assets/i5gam/images/onandon-stamp.png">
          </td>
        </tr>
        <tr>
          <th>주소</th>
          <td>서울시 강동구 천호동 현대코아 아파트상가 301호</td>
        </tr>
        <tr>
          <th>전화번호</th>
          <td>02-478-8360</td>
        </tr>
        <tr>
          <th>팩스번호</th>
          <td>02-478-8366</td>
        </tr>
        </tbody>
      </table>
    </div>
    <table class="tb-col instt-tbl mgt30 __pd-half">
      <colgroup>
        <col style="width:auto;"/>
        <col style="width:15%" />
        <col style="width:10%" />
        <col style="width:10%" />
        <col style="width:15%" />
        <col style="width:15%" />
      </colgroup>
      <thead>
      <tr>
        <th style="padding: 7px 5px;">상품명</th>
        <th style="padding: 7px 5px;">규격</th>
        <th style="padding: 7px 5px;">단위</th>
        <th style="padding: 7px 5px;">수량</th>
        <th style="padding: 7px 5px;">단가</th>
        <th class="last" style="padding: 7px 5px;">금액</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(info, index) in deliveryConfirmList"
          :key="'info_'+index">
        <td class="__left">{{info.goodsNm}}</td>
        <td class="__right">{{info.goodsStandard}}</td>
        <td>{{info.goodsKorUnit}}</td>
        <td class="__right">{{info.goodsCnt}}</td>
        <td class="__right"> {{$onbiLib.addComma(info.goodsUnitAmount)}}원</td>
        <td class="__right last">{{$onbiLib.addComma(info.goodsUnitAmount * info.goodsCnt)}}원</td>
      </tr>
      <tr v-for="(info, index) in 20-deliveryConfirmList.length"
          :key="'info'+index"
          style="height: 31px;">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="last"></td>
      </tr>
      <tr style="">
        <td colspan="5">합  계</td>
        <td class="__right">{{$onbiLib.addComma(priceInfo.totPrice)}}원</td>

      </tr>
      </tbody>
    </table>
    <div class="mgt20">
      <div class="box-gw-common-search">
        <div class="__common-search">
          <table>
            <colgroup>
              <col style="width:45%" />
            </colgroup>
            <tbody>
            <tr>
              <td class="pdl50" style="text-align:center; font-weight: bolder; font-size: 17px;">
                <span class="pc07">위와 같이 납품하오니 확인하여 주시기 바랍니다.</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="pdt40" style="margin-bottom: 70px;">
      <img src="../../../../assets/i5gam/images/onandon-logo.png"
           style="float: left; width: 190px;"
           alt="온앤온정보시스템 로고">
      <img src="../../../../assets/i5gam/images/img-h1-main-logo.png"
           style="float: right;"
           alt="아이오감 로고">
    </div>
  </div>
</template>
<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
 * 2.1. Import
 *======================================================================================*/


import {jsPDF} from "jspdf";
import html2canvas from "html2canvas";

export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  name: "deliveryConfirmPopup",
  props: ['param'],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data :function (){
    return{
      initAt: false,
      deliveryConfirmList: new Array(),
      payInfo: this.param.payInfo,
      srvcInfo: this.param.srvcInfo,
      orderInfo : this.param.orderInfo,
      priceInfo : this.param.priceInfo,
      orderPaySe : this.param.orderPaySe,
      mode: 'download',
      printPadding: {
        top: 80,
        right: 40,
        bottom: 80,
        left: 40
      },
      timer : null
    }
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  computed: {
    dayInfo: function(){
      return this.$store.getters.getDayInfo;
    },
  },
  methods: {
    init: function (){
      this.initAt = true;

      this.searchDeliveryList();
    },
    searchDeliveryList : function () {
      let orderInfo=this.orderInfo;
      console.log(orderInfo);
      let setFieldList = new Array();
      let goodsArray = new Array();
      if(orderInfo.payMean == '999'){
        if(orderInfo.detectorCnt > 0){
          goodsArray.push('GI0001,' + orderInfo.detectorCnt + ',대,' + this.priceInfo.detectorCalTotPrice);
        }
        if(orderInfo.tagCnt > 0){
          goodsArray.push('GI0002,' + orderInfo.tagCnt + ',개,' + this.priceInfo.tagTotPrice);
        }
      }else if(orderInfo.payMean != '999'){
        if(this.orderPaySe == 'ALL'){
          goodsArray = orderInfo.goodsInfo.split('/');
        }else if(this.orderPaySe == 'DETECTOR'){
          goodsArray = orderInfo.detectorGoodsInfo.split('/');
        }else if(this.orderPaySe == 'TAG'){
          goodsArray = orderInfo.tagGoodsInfo.split('/');
        }
      }
      console.log(goodsArray);

      goodsArray.forEach(function(goodsInfoTxt){
        let goodsInfo = goodsInfoTxt.split(',');

        if(orderInfo.orderSe == '001'){ // 보조금
          if(goodsInfo[0] == 'GI0001') {
            setFieldList.push({goodsNm : '에이티엔 걸음마 NFC 리더기', goodsStandard :'CCAL-100',
              goodsKorUnit : goodsInfo[2], goodsCnt : Number(goodsInfo[1]), goodsUnitAmount : 300000 });

          }else if(goodsInfo[0] == 'GI0002'){
            setFieldList.push({goodsNm : '에이티엔 걸음마 NFC 태그', goodsStandard :'LIBERO-30042',
              goodsKorUnit : goodsInfo[2], goodsCnt : Number(goodsInfo[1]), goodsUnitAmount : 5000 });
          }
        }else{ //자부담금
          if(goodsInfo[0] == 'GI0001') {
            setFieldList.push({goodsNm : '에이티엔 걸음마 NFC 리더기(추가)', goodsStandard :'CCAL-100',
              goodsKorUnit : goodsInfo[2], goodsCnt : Number(goodsInfo[1]), goodsUnitAmount : 220000 });

          }else if(goodsInfo[0] == 'GI0002'){
            setFieldList.push({goodsNm : '에이티엔 걸음마 NFC 태그', goodsStandard :'LIBERO-30042',
              goodsKorUnit : goodsInfo[2], goodsCnt : Number(goodsInfo[1]), goodsUnitAmount : 5000 });
          }
        }

      })
      this.deliveryConfirmList = setFieldList;

      this.$store.commit('setPageMaskShowAt',true);
      this.$nextTick(function () {
        this.pdfDownload();
      })

    },
    pdfDownload : function (){
      this.timer = setInterval(function(){
        this.drawCanvasToPdf();
        clearInterval(this.timer);
      }.bind(this), 3000);
    },
    drawCanvasToPdf: function(){
      this.pageList = new Array();
      let index = 0;
      let page = document.getElementsByClassName('print_page')

      for(const pageElement of page){
        pageElement.style.padding
            = this.printPadding.top + 'px '
            + this.printPadding.right + 'px '
            + this.printPadding.left + 'px ';
        this.pageList.push({setAt:false,dataURL : null,width:null,height:null})

        this.drawCanvas(pageElement,index);
        index++;
      }

      this.drawInterVal = setInterval(function(){
        let cnt = 0;
        this.pageList.forEach(function(info){
          if(info.setAt) cnt += 1;
        })
        if(this.pageList.length == cnt&&!this.createPdfAt){
          this.createPdfAt = true;
          const doc = new jsPDF({
            'orientation': 'p',
            'unit': 'mm',
            'format': 'a4',
            'compressPdf': true
          });

          const imgWidth   = 210;

          this.pageList.forEach(function(info,index){
            let imgHeight = (info.height * imgWidth / info.width);
            if(index > 0){ doc.addPage(); }
            doc.addImage(
                info.dataURL,
                'PNG',
                0,
                0,
                imgWidth ,
                imgHeight,
                'image' + index,
                'SLOW');
          })

          clearInterval(this.drawInterVal);
          this.$store.commit('setPageMaskShowAt',false);
          this.createPdfAt = false;

          if(this.mode == 'download'){
            let fileNm = '납품확인서_'+this.dayInfo.ymd;
            if(this.downloadFileNm != null){
              fileNm = this.downloadFileNm;
            }
            doc.save(fileNm+'.pdf');
          }

          this.finishPdf();
        }
      }.bind(this), 1000);
    },
    drawCanvas: function(pageElement,pageIndex){
      const dpi = 300;
      const scale = 2;

      html2canvas(
          pageElement,
          {
            dpi: dpi,
            scale: scale,
            scrollX : 0,
            scrollY : 0
          }
      )
          .then(function(canvas){
            let pageInfo = this.pageList[pageIndex];
            pageInfo.dataURL = canvas.toDataURL('image/png');
            pageInfo.width   = canvas.width;
            pageInfo.height  = canvas.height;
            pageInfo.setAt   = true;
          }.bind(this));
    },
    finishPdf: function(){
      this.$store.commit('closePopup');
    },

  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted: function () {
    this.init();
  }


}
</script>

<style scoped>

</style>